import {k} from './kaplay.js'

export const bgm = k.play("bgm", {
  volume: 0.8,
  loop: true,
  paused: true
})

export const scroll = k.play("scroll", {
  volume: 0.2,
  speed: 0.3,
  loop: true,
  paused: true
})

export const click = k.play("click", {
  paused: true
})
